"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _MediaSourceInstance = _interopRequireDefault(require("./MediaSourceInstance"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MediaItemInstance model module.
 * @module model/MediaItemInstance
 * @version 3.0
 */
var MediaItemInstance = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MediaItemInstance</code>.
   * @alias module:model/MediaItemInstance
   */
  function MediaItemInstance() {
    _classCallCheck(this, MediaItemInstance);
    MediaItemInstance.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MediaItemInstance, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>MediaItemInstance</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MediaItemInstance} obj Optional instance to populate.
     * @return {module:model/MediaItemInstance} The populated <code>MediaItemInstance</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MediaItemInstance();
        if (data.hasOwnProperty('itemId')) {
          obj['itemId'] = _ApiClient["default"].convertToType(data['itemId'], 'Number');
        }
        if (data.hasOwnProperty('itemLegacyId')) {
          obj['itemLegacyId'] = _ApiClient["default"].convertToType(data['itemLegacyId'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('offlineAllowed')) {
          obj['offlineAllowed'] = _ApiClient["default"].convertToType(data['offlineAllowed'], 'Boolean');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], 'String');
        }
        if (data.hasOwnProperty('mediaSourceInstances')) {
          obj['mediaSourceInstances'] = _ApiClient["default"].convertToType(data['mediaSourceInstances'], [_MediaSourceInstance["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MediaItemInstance</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaItemInstance</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['itemLegacyId'] && !(typeof data['itemLegacyId'] === 'string' || data['itemLegacyId'] instanceof String)) {
        throw new Error("Expected the field `itemLegacyId` to be a primitive type in the JSON string but got " + data['itemLegacyId']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['tags'] && !(typeof data['tags'] === 'string' || data['tags'] instanceof String)) {
        throw new Error("Expected the field `tags` to be a primitive type in the JSON string but got " + data['tags']);
      }
      if (data['mediaSourceInstances']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['mediaSourceInstances'])) {
          throw new Error("Expected the field `mediaSourceInstances` to be an array in the JSON data but got " + data['mediaSourceInstances']);
        }
        // validate the optional field `mediaSourceInstances` (array)
        var _iterator = _createForOfIteratorHelper(data['mediaSourceInstances']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _MediaSourceInstance["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} itemId
 */
MediaItemInstance.prototype['itemId'] = undefined;

/**
 * @member {String} itemLegacyId
 */
MediaItemInstance.prototype['itemLegacyId'] = undefined;

/**
 * @member {String} description
 */
MediaItemInstance.prototype['description'] = undefined;

/**
 * @member {String} name
 */
MediaItemInstance.prototype['name'] = undefined;

/**
 * @member {Boolean} offlineAllowed
 */
MediaItemInstance.prototype['offlineAllowed'] = undefined;

/**
 * @member {String} type
 */
MediaItemInstance.prototype['type'] = undefined;

/**
 * @member {String} tags
 */
MediaItemInstance.prototype['tags'] = undefined;

/**
 * @member {Array.<module:model/MediaSourceInstance>} mediaSourceInstances
 */
MediaItemInstance.prototype['mediaSourceInstances'] = undefined;
var _default = exports["default"] = MediaItemInstance;